module.exports = __webpack_public_path__ + "static/media/vibin_portfolio.e2110cfa.png";